export const introduce = {
  text: `### 使用方法
  + • 绿色区域（30d MA 上穿 60d MA）：算力开始回升，根据历史回测往往对应市场的底部。
  
  ### 指标原理
  + 哈希带是一个判断市场底部的指标；我们通过哈希率的30d MA 和 60d MA，创建了该指标。
  + 当哈希率的30d MA超过60d MA时（图中阴影部分），表明矿工投降结束，哈希算力恢复稳定，价格动量由负转正。
  + 更多介绍见：[关于哈希带的原理介绍](https://medium.com/capriole/hash-ribbons-bitcoin-bottoms-60da13095836)
  
  ### 创作者
  该指标由 [Charles Edwards](https://twitter.com/caprioleio) 创建。`,
  height: 1410,
};
